// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.robinhood.wallet",
    name: "Robinhood Wallet",
    homepage: "https://robinhood.com/web3-wallet/",
    image_id: "dfe0e3e3-5746-4e2b-12ad-704608531500",
    app: {
        browser: "https://robinhood.com/web3-wallet/",
        ios: "https://robinhood.com/web3-wallet/",
        android: "https://play.google.com/store/apps/details?id=com.robinhood.gateway",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://robinhood.com/web3-wallet/",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.robinhood.wallet",
    mobile: {
        native: "robinhood-wallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map